import constants from '@/app-configs/constants'
import Settings from './settings'
import cases from './cases'
import clients from './clients'
import debtor from './debtor'
import eventlogs from './eventlogs'
import orders from './orders'
import letters from './letters'
import templates from './templates'
import customfields from './customfields'
import lists from './lists'
import aksdebtors from './aksdebtors'

export default async function mainComponent() {
  const settings = await Settings()

  return [
    {
      title: 'DEBTIA_HOME',
      route: 'home',
      icon: 'HomeIcon',
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
    {
      title: 'DEBTIA_TRANSLATIONS',
      route: 'translations',
      icon: 'GridIcon',
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
      show: true,
    },
    {
      title: 'DEBTIA_ROLE_MANAGEMENT',
      route: 'role-management',
      icon: 'GridIcon',
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
      show: true,
    },
    ...cases,
    ...clients,
    ...debtor,
    ...aksdebtors,
    ...customfields,
    ...eventlogs,
    ...orders,
    ...letters,
    ...templates,
    ...lists,
    ...settings,
  ]
}
